import React from "react";
import {
    Dialog,
    DialogContent,
    DialogTitle,
    DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export default function SuccessModal({ data, onClose }) {
    if (!data) return null;
    const total = data.order_total ?? (data.amount_total || 0) / 100;
    const name = data.customer?.name || "Friend";
    const email = data.customer?.email || "";

    return (
        <Dialog open={!!data} onOpenChange={(v) => !v && onClose()}>
            <DialogContent
                data-testid="success-modal"
                className="max-w-md w-[calc(100vw-2rem)] bg-cream rounded-[24px] border-0 p-0 overflow-hidden text-center"
            >
                <div className="relative bg-forest text-white py-10 px-6">
                    <div className="absolute inset-0 opacity-20 pointer-events-none">
                        <span className="absolute top-3 left-6 text-3xl animate-float-slow">
                            🎉
                        </span>
                        <span className="absolute top-8 right-8 text-3xl animate-float-slower">
                            ✨
                        </span>
                        <span className="absolute bottom-4 left-10 text-2xl animate-float-slower">
                            🌴
                        </span>
                    </div>
                    <div className="relative">
                        <div className="text-6xl">🎉</div>
                        <DialogTitle className="mt-3 font-serif font-black text-3xl">
                            Order Placed!
                        </DialogTitle>
                        <DialogDescription className="mt-2 text-mint">
                            Mèsi anpil — thank you so much.
                        </DialogDescription>
                    </div>
                </div>
                <div className="p-6 space-y-3">
                    <p className="text-navy">
                        Thank you,{" "}
                        <span className="font-bold">{name}</span>!
                    </p>
                    {email && (
                        <p className="text-sm text-muted2">
                            A confirmation is on its way to{" "}
                            <span className="font-bold text-navy">{email}</span>
                            .
                        </p>
                    )}
                    <div className="bg-mint/60 rounded-2xl p-4 mt-3">
                        <p className="text-[11px] uppercase tracking-widest font-bold text-forest">
                            Total Paid
                        </p>
                        <p
                            className="font-display text-5xl text-forest"
                            data-testid="success-total"
                        >
                            ${total.toFixed(2)}
                        </p>
                        <p className="text-sm text-navy mt-1">
                            Delivery to Greater Boston, MA 🇭🇹
                        </p>
                    </div>
                    {data.order_id && (
                        <p className="text-[11px] text-muted2">
                            Order ID:{" "}
                            <span className="font-mono">{data.order_id}</span>
                        </p>
                    )}
                    <Button
                        data-testid="success-close-btn"
                        onClick={onClose}
                        className="mt-2 w-full rounded-full bg-gold hover:bg-goldDark text-navy font-bold py-5"
                    >
                        Close
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
}
